import httpClient from "@/plugins/axios";

export const getPeople = async (page, pageSize = 10, department = null, search = null, ordering = null) => {
    const response = await httpClient.get(`/v1/people/?page=${page}&page_size=${pageSize}`,
        {
            params: {
                department,
                ordering: ordering ?? 'first_name',
                search
            }
        }
    );
    return response;
}

export const searchPersons = async (query) => {
    const response = await httpClient.get(`/v1/people/search/?search=${encodeURIComponent(query)}`);
    return response;
}